// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminReviewsForm-space1-pyzkC {
	margin-bottom: 6px !important;
}

.AdminReviewsForm-space2-GYM4x {
	margin-bottom: 12px !important;
}

.AdminReviewsForm-space3-fEHw7 {
	margin-bottom: 18px !important;
}

.AdminReviewsForm-space4-C0XmM {
	margin-bottom: 24px !important;
}

.AdminReviewsForm-space5-aHPh6 {
	margin-bottom: 30px !important;
}

.AdminReviewsForm-space6-P8Jmz {
	margin-bottom: 36px !important;
}

.AdminReviewsForm-space7-JKMGc {
	margin-bottom: 42px !important;
}

.AdminReviewsForm-space8-KToMi {
	margin-bottom: 48px !important;
}

.AdminReviewsForm-spaceTop1-HiGfJ {
	margin-top: 6px !important;
}

.AdminReviewsForm-spaceTop2-CAiMa {
	margin-top: 12px !important;
}

.AdminReviewsForm-spaceTop3-EQ1de {
	margin-top: 18px !important;
}

.AdminReviewsForm-spaceTop4-Ms_eO {
	margin-top: 24px !important;
}

.AdminReviewsForm-spaceTop5-EL4qG {
	margin-top: 30px !important;
}

.AdminReviewsForm-spaceTop6-GGorB {
	margin-top: 36px !important;
}

.AdminReviewsForm-spaceTop7-xtWeS {
	margin-top: 42px !important;
}

.AdminReviewsForm-spaceTop8-tQJyj {
	margin-top: 48px !important;
}

.AdminReviewsForm-noMargin-S5KtH {
	margin: 0px !important;
}

.AdminReviewsForm-padding1-S5_ro {
	padding-bottom: 6px !important;
}

.AdminReviewsForm-padding2-ib6F8 {
	padding-bottom: 12px !important;
}

.AdminReviewsForm-padding3-lrLLE {
	padding-bottom: 18px !important;
}

.AdminReviewsForm-padding4-A9oir {
	padding-bottom: 24px !important;
}

.AdminReviewsForm-padding5-sPnAz {
	padding-bottom: 30px !important;
}

.AdminReviewsForm-padding6-fHkK7 {
	padding-bottom: 36px !important;
}

.AdminReviewsForm-padding7-C8O7h {
	padding-bottom: 42px !important;
}

.AdminReviewsForm-paddingTop1-Ax1jR {
	padding-top: 6px !important;
}

.AdminReviewsForm-paddingTop2-b7jYF {
	padding-top: 12px !important;
}

.AdminReviewsForm-paddingTop3-PNyJt {
	padding-top: 18px !important;
}

.AdminReviewsForm-paddingTop4-so5vE {
	padding-top: 24px !important;
}

.AdminReviewsForm-paddingTop5-MrR6e {
	padding-top: 30px !important;
}

.AdminReviewsForm-paddingTop6-X10Z9 {
	padding-top: 36px !important;
}

.AdminReviewsForm-paddingTop7-_ar4w {
	padding-top: 42px !important;
}

.AdminReviewsForm-noPadding-CNgjy {
	padding: 0px !important;
}

.AdminReviewsForm-spaceMarginBottom0-ewQU9 {
	margin-bottom: 0;
}

.AdminReviewsForm-textBold-KBBa6 {
	font-weight: 500 !important;
}

.AdminReviewsForm-textBolder-nYmfH {
	font-weight: 700 !important;
}

.AdminReviewsForm-textNormal-Wm66Z {
	font-weight: normal !important;
}

/*New Design Text Colors */

.AdminReviewsForm-textDarkBlue-G8v4R {
	color: rgb(20, 39, 94) !important;
}

.AdminReviewsForm-textLightBlue-AX7Ag {
	color: rgb(57, 87, 106) !important;
}

.AdminReviewsForm-textLightSandleGreen-PYS5o {
	color: rgb(76, 86, 41) !important;
}

.AdminReviewsForm-textLightBrown-qcfY9 {
	color: rgb(115, 79, 33) !important;
}

.AdminReviewsForm-textMediumMaroon-EMxbk {
	color: rgb(87, 37, 51) !important;
}

.AdminReviewsForm-textBrown-kMAwJ {
	color: rgb(160, 47, 24) !important;
}

.AdminReviewsForm-textMaroon-n039p {
	color: rgb(155, 49, 67) !important;
}

.AdminReviewsForm-textDarkBrown-guwch {
	color: rgb(83, 18, 16) !important;
}

.AdminReviewsForm-textMediumBrown-OdlUv {
	color: rgb(142, 28, 10) !important;
}

.AdminReviewsForm-textSkyBlue-WLMpX {
	color: rgb(37, 117, 141) !important;
}

.AdminReviewsForm-textGray-s6b9m {
	color: rgb(77, 65, 51) !important;
}

.AdminReviewsForm-errorMessage-WRary {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.AdminReviewsForm-userText-rPKnj {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.AdminReviewsForm-panelHeader-S5cfa {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.AdminReviewsForm-exportSection-YBJtE {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.AdminReviewsForm-exportSectionGridSub-V31AM {
	grid-template-columns: 50% 49% !important;
}

.AdminReviewsForm-exportText-aj_sc {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.AdminReviewsForm-exportLinkImg-WN84w {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.AdminReviewsForm-exportImg-Iqqz4 {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminReviewsForm-linkBtn-pBdw7 {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.AdminReviewsForm-table-zwXJg {
	display: table;
}

.AdminReviewsForm-tableRow-OEJEj {
	display: table-row;
}

.AdminReviewsForm-tableCell-OhQei {
	display: table-cell;
	float: none;
}

.AdminReviewsForm-formGroup-cv1MB {
	margin-bottom: 6px;
}

.AdminReviewsForm-marginTop0-FAy1A {
	margin-top: 0;
}

.AdminReviewsForm-marginBottom20-WWEi1 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.AdminReviewsForm-bannerImageBg-Qyms7 {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.AdminReviewsForm-bannerDelete-GzRVH {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.AdminReviewsForm-exportLink-YiZ2K {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminReviewsForm-seachContent-bA4VI {
	padding-left: 0px;
	margin-bottom: 5px;
}

.AdminReviewsForm-marginBottom9-zYE1Z {
	margin-bottom: 9px;
}

.AdminReviewsForm-spaceTop52-YTpoM {
	margin-top: 52px;
}

.AdminReviewsForm-profileViewInner-lT1r0 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.AdminReviewsForm-profileViewMain-PA4Tn {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.AdminReviewsForm-profileViewlabel-XQqrd {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.AdminReviewsForm-profileViewMainContent-C2Akm {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.AdminReviewsForm-reviewsFormStar-kFGue {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.AdminReviewsForm-reviewsFormStar-kFGue svg {
	cursor: pointer;
}

.AdminReviewsForm-addLanguageText-n8YNZ {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.AdminReviewsForm-exportSection-YBJtE {
		grid-template-columns: 100%;
	}

	.AdminReviewsForm-spaceTop52-YTpoM {
		margin-top: 18px;
	}

	.AdminReviewsForm-exportText-aj_sc {
		float: none;
		margin-top: 12px;
	}

	.AdminReviewsForm-exportSectionGridSub-V31AM {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.AdminReviewsForm-profileViewlabel-XQqrd {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminReviewsForm-profileViewMainContent-C2Akm {
		width: 100%;
		text-align: center;
	}

	.AdminReviewsForm-panelHeader-S5cfa {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.AdminReviewsForm-starSize-_z6t6 {
    font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/AdminReviewsForm/AdminReviewsForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACvN3E;IACI,eAAe;AACnB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n.starSize {\n    font-size: 22px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `AdminReviewsForm-space1-pyzkC`,
	"space2": `AdminReviewsForm-space2-GYM4x`,
	"space3": `AdminReviewsForm-space3-fEHw7`,
	"space4": `AdminReviewsForm-space4-C0XmM`,
	"space5": `AdminReviewsForm-space5-aHPh6`,
	"space6": `AdminReviewsForm-space6-P8Jmz`,
	"space7": `AdminReviewsForm-space7-JKMGc`,
	"space8": `AdminReviewsForm-space8-KToMi`,
	"spaceTop1": `AdminReviewsForm-spaceTop1-HiGfJ`,
	"spaceTop2": `AdminReviewsForm-spaceTop2-CAiMa`,
	"spaceTop3": `AdminReviewsForm-spaceTop3-EQ1de`,
	"spaceTop4": `AdminReviewsForm-spaceTop4-Ms_eO`,
	"spaceTop5": `AdminReviewsForm-spaceTop5-EL4qG`,
	"spaceTop6": `AdminReviewsForm-spaceTop6-GGorB`,
	"spaceTop7": `AdminReviewsForm-spaceTop7-xtWeS`,
	"spaceTop8": `AdminReviewsForm-spaceTop8-tQJyj`,
	"noMargin": `AdminReviewsForm-noMargin-S5KtH`,
	"padding1": `AdminReviewsForm-padding1-S5_ro`,
	"padding2": `AdminReviewsForm-padding2-ib6F8`,
	"padding3": `AdminReviewsForm-padding3-lrLLE`,
	"padding4": `AdminReviewsForm-padding4-A9oir`,
	"padding5": `AdminReviewsForm-padding5-sPnAz`,
	"padding6": `AdminReviewsForm-padding6-fHkK7`,
	"padding7": `AdminReviewsForm-padding7-C8O7h`,
	"paddingTop1": `AdminReviewsForm-paddingTop1-Ax1jR`,
	"paddingTop2": `AdminReviewsForm-paddingTop2-b7jYF`,
	"paddingTop3": `AdminReviewsForm-paddingTop3-PNyJt`,
	"paddingTop4": `AdminReviewsForm-paddingTop4-so5vE`,
	"paddingTop5": `AdminReviewsForm-paddingTop5-MrR6e`,
	"paddingTop6": `AdminReviewsForm-paddingTop6-X10Z9`,
	"paddingTop7": `AdminReviewsForm-paddingTop7-_ar4w`,
	"noPadding": `AdminReviewsForm-noPadding-CNgjy`,
	"spaceMarginBottom0": `AdminReviewsForm-spaceMarginBottom0-ewQU9`,
	"textBold": `AdminReviewsForm-textBold-KBBa6`,
	"textBolder": `AdminReviewsForm-textBolder-nYmfH`,
	"textNormal": `AdminReviewsForm-textNormal-Wm66Z`,
	"textDarkBlue": `AdminReviewsForm-textDarkBlue-G8v4R`,
	"textLightBlue": `AdminReviewsForm-textLightBlue-AX7Ag`,
	"textLightSandleGreen": `AdminReviewsForm-textLightSandleGreen-PYS5o`,
	"textLightBrown": `AdminReviewsForm-textLightBrown-qcfY9`,
	"textMediumMaroon": `AdminReviewsForm-textMediumMaroon-EMxbk`,
	"textBrown": `AdminReviewsForm-textBrown-kMAwJ`,
	"textMaroon": `AdminReviewsForm-textMaroon-n039p`,
	"textDarkBrown": `AdminReviewsForm-textDarkBrown-guwch`,
	"textMediumBrown": `AdminReviewsForm-textMediumBrown-OdlUv`,
	"textSkyBlue": `AdminReviewsForm-textSkyBlue-WLMpX`,
	"textGray": `AdminReviewsForm-textGray-s6b9m`,
	"errorMessage": `AdminReviewsForm-errorMessage-WRary`,
	"userText": `AdminReviewsForm-userText-rPKnj`,
	"panelHeader": `AdminReviewsForm-panelHeader-S5cfa`,
	"exportSection": `AdminReviewsForm-exportSection-YBJtE`,
	"exportSectionGridSub": `AdminReviewsForm-exportSectionGridSub-V31AM`,
	"exportText": `AdminReviewsForm-exportText-aj_sc`,
	"exportLinkImg": `AdminReviewsForm-exportLinkImg-WN84w`,
	"exportImg": `AdminReviewsForm-exportImg-Iqqz4`,
	"linkBtn": `AdminReviewsForm-linkBtn-pBdw7`,
	"table": `AdminReviewsForm-table-zwXJg`,
	"tableRow": `AdminReviewsForm-tableRow-OEJEj`,
	"tableCell": `AdminReviewsForm-tableCell-OhQei`,
	"formGroup": `AdminReviewsForm-formGroup-cv1MB`,
	"marginTop0": `AdminReviewsForm-marginTop0-FAy1A`,
	"marginBottom20": `AdminReviewsForm-marginBottom20-WWEi1`,
	"bannerImageBg": `AdminReviewsForm-bannerImageBg-Qyms7`,
	"bannerDelete": `AdminReviewsForm-bannerDelete-GzRVH`,
	"exportLink": `AdminReviewsForm-exportLink-YiZ2K`,
	"seachContent": `AdminReviewsForm-seachContent-bA4VI`,
	"marginBottom9": `AdminReviewsForm-marginBottom9-zYE1Z`,
	"spaceTop52": `AdminReviewsForm-spaceTop52-YTpoM`,
	"profileViewInner": `AdminReviewsForm-profileViewInner-lT1r0`,
	"profileViewMain": `AdminReviewsForm-profileViewMain-PA4Tn`,
	"profileViewlabel": `AdminReviewsForm-profileViewlabel-XQqrd`,
	"profileViewMainContent": `AdminReviewsForm-profileViewMainContent-C2Akm`,
	"reviewsFormStar": `AdminReviewsForm-reviewsFormStar-kFGue`,
	"addLanguageText": `AdminReviewsForm-addLanguageText-n8YNZ`,
	"starSize": `AdminReviewsForm-starSize-_z6t6`
};
module.exports = ___CSS_LOADER_EXPORT___;
